import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

export default function User(props) {
  const orange = getColorValue('illustrationOrange');
  const blue = getColorValue('illustrationAccent');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <g fill={orange}>
        <path d="m78.7483 223.198c.07-.41.1-.85.09-1.32s-.05-.92-.13-1.33c-.48-2.49-2.23-4-4.67-4.36-.42-.06-.85-.09-1.3-.08s-.92.05-1.35.13c-2.42.44-4.13 1.99-4.55 4.48-.07.42-.1.87-.1 1.34s.05.9.13 1.32c.48 2.47 2.23 3.98 4.67 4.35.43.07.88.1 1.36.09s.89-.05 1.3-.12c2.43-.43 4.14-1.99 4.55-4.49z" />
        <path d="m78.0483 173.388c.13-.81.2-1.67.18-2.58s-.1-1.79-.26-2.61c-.94-4.85-4.36-7.81-9.11-8.51-.81-.12-1.66-.18-2.54-.16s-1.8.1-2.64.25c-4.73.86-8.06 3.89-8.87 8.74-.14.82-.2 1.69-.19 2.61s.1 1.77.26 2.57c.94 4.82 4.35 7.77 9.11 8.5.84.13 1.73.19 2.65.18.88-.01 1.73-.09 2.54-.23 4.74-.84 8.08-3.89 8.88-8.76z" />
        <path d="m146.748 112.908c.62-3.79.92-7.82.86-12.07-.06-4.3098-.47-8.3798-1.21-12.1998-4.41-22.73-20.43-36.56-42.68-39.86-3.8005-.56-7.7705-.83-11.9005-.77-4.31.06-8.44.46-12.37 1.17-22.16 4.01-37.77 18.24-41.56 40.95-.64 3.84-.94 7.92-.88 12.2298.06 4.25.47 8.27 1.2 12.04 4.38 22.57 20.39 36.39 42.69 39.8 3.95.6 8.08.89 12.39.83 4.13-.06 8.1005-.43 11.8805-1.1 22.18-3.92 37.83-18.21 41.58-41.02z" />
      </g>
      <path
        d="m111.457 86.5384c.02 1.48-.08 2.89-.3 4.21-1.31 7.96-6.77 12.9396-14.5097 14.3096-1.31.23-2.64.36-4.14.38s-2.94-.08-4.32-.29c-7.78-1.18-13.36-5.9996-14.89-13.8796-.26-1.32-.4-2.72-.42-4.2-.02-1.51.09-2.93.31-4.27 1.32-7.93 6.77-12.89 14.5-14.29 1.37-.25 2.81-.39 4.31-.41 1.44-.02 2.83.07 4.15.27 7.7597 1.16 13.3497 5.98 14.8897 13.91.25 1.34.4 2.76.42 4.26z"
        fill={blue}
      />
      <path
        d="m92.577 108.628c19.529-.339 32.308 9.059 31.85 34.306l.07 3.934c-5.64 3.401-12.14 5.781-19.34 7.051-3.78.67-7.75 1.04-11.88 1.1-4.31.06-8.44-.23-12.39-.83-6.72-1.02-12.85-3.01-18.28-5.88l-.07-4.301c-.44-25.23 11.71-35.06 30.04-35.38z"
        fill={blue}
      />
      <path
        d="m237.097 148.658c.62-3.79.92-7.82.86-12.07-.06-4.31-.47-8.38-1.21-12.2-4.41-22.73-20.43-36.5598-42.68-39.8598-3.8-.56-7.77-.83-11.9-.77-4.31.06-8.44.46-12.37 1.17-22.16 4.01-37.77 18.2398-41.56 40.9498-.64 3.84-.94 7.92-.88 12.23.06 4.25.47 8.27 1.2 12.04 4.38 22.57 20.39 36.39 42.69 39.8 3.95.6 8.08.89 12.39.83 4.13-.06 8.1-.43 11.88-1.1 22.18-3.92 37.83-18.21 41.58-41.02z"
        fill={orange}
      />
      <path
        d="m201.807 122.288c.02 1.48-.08 2.89-.3 4.21-1.31 7.96-6.77 12.94-14.51 14.31-1.31.23-2.7.36-4.14.38-1.5.02-2.94-.08-4.32-.29-7.78-1.18-13.36-6-14.89-13.88-.26-1.32-.4-2.72-.42-4.2-.02-1.51.09-2.93.31-4.27 1.32-7.93 6.77-12.89 14.5-14.29 1.37-.25 2.81-.39 4.31-.41 1.44-.02 2.83.07 4.15.27 7.76 1.16 13.35 5.98 14.89 13.91.25 1.34.4 2.76.42 4.26z"
        fill={blue}
      />
      <path
        d="m182.929 144.388c19.528-.34 32.308 9.059 31.85 34.305l.07 3.935c-5.64 3.4-12.14 5.78-19.34 7.05-3.78.67-7.75 1.04-11.88 1.1-4.31.06-8.44-.23-12.39-.83-6.72-1.02-12.85-3.01-18.28-5.88l-.07-4.3c-.44-25.23 11.71-35.06 30.04-35.38z"
        fill={blue}
      />
      <path
        d="m148.638 195.028c.38-2.29.55-4.71.52-7.28-.04-2.6-.29-5.05-.73-7.36-2.66-13.71-12.32-22.04-25.73-24.04-2.29-.34-4.69-.5-7.18-.46s-5.09.28-7.46.71c-13.3597 2.42-22.7696 11-25.0596 24.7-.39 2.31-.57 4.77-.53 7.38.04 2.56.28 4.99.72 7.26 2.64 13.61 12.29 21.94 25.7396 24 2.38.36 4.87.54 7.47.5 2.49-.03 4.88-.26 7.16-.66 13.38-2.36 22.81-10.98 25.08-24.74z"
        fill={orange}
      />
      <path
        d="m127.357 179.118c.01.9-.05 1.74-.18 2.54v-.01c-.79 4.8-4.08 7.81-8.75 8.63-.8.14-1.63.22-2.5.23-.91.02-1.78-.04-2.61-.17-4.69-.71-8.06-3.62-8.98-8.37-.15-.79-.24-1.64-.25-2.53-.01-.9.06-1.76.19-2.57.79-4.78 4.08-7.78 8.74-8.62.82-.15 1.73-.24 2.6-.25s1.7.04 2.5.16c4.68.7 8.05 3.61 8.98 8.39.16.81.25 1.66.26 2.57z"
        fill={blue}
      />
      <path
        d="m115.967 192.448c11.78-.2 19.49 5.46 19.21 20.69l.04 2.38c-3.4 2.05-7.32 3.48-11.66 4.25-2.28.4-4.67.63-7.16.66-2.6.04-5.09-.14-7.47-.5-4.05-.62-7.75-1.82-11.0202-3.55l-.05-2.59c-.27-15.22 7.0602-21.15 18.1102-21.34z"
        fill={blue}
      />
      <path
        d="m146.747 112.908c.62-3.79.92-7.82.86-12.07-.03-2.3-.17-4.52-.4-6.67-9.93 7.15-16.66 17.85-18.97 31.72-.64 3.84-.94 7.92-.88 12.23.03 2.28.17 4.49.4 6.64 9.96-7.15 16.7-17.9 18.99-31.85z"
        fill={illustrationColors.staticRed}
      />
      <path
        d="m148.617 181.489c-.06-.37-.12-.74-.19-1.1-2.08-10.73-8.46-18.15-17.57-21.83 3.55 9.81 9.67 17.52 17.75 22.93z"
        fill={illustrationColors.staticRed}
      />
    </svg>
  );
}
